import { app } from "js/namespaces";

const shouldShowProBadge = (feature, workspaceId) => {
    if (!feature) return false;
    const featureDisabled = app.user.features && !app.user.features.isFeatureEnabled(feature, workspaceId);
    return featureDisabled;
};

export default shouldShowProBadge;
